import swal from 'sweetalert2';
import {db, auth} from "@/firebase/init";
import refreshToken from "./refreshTokenMixin";
import store from "../store/store";
import crypto from 'crypto-js';

export default {
	mixins:[refreshToken],
	data () {
		return {
			gotoNuxtLoader: false
		}
	},
	computed: {
		user() {
			return this.$store.getters.user;
		},
		userToken() {
			return this.$store.getters.getUserToken;
		},
		admin () {
			return this.$store.getters.admin;
		},
		aesSecret () {
			return this.$store.getters['crypto/aesSecret']
		}
	},
	mounted() {
		this.getServerToken();
	},
	methods: {
		async goToNuxt (docId) {
			this.gotoNuxtLoader = true
			await this.saveRecentlyAccessedUserToDB(docId)

			this.gotoNuxtLoader = false
			// const encrypetUid = crypto.AES.encrypt(docId, this.aesSecret).toString().split('/').join('Por21Ld')
			// console.log(encrypetUid)
			window.open(`https://wpo.bigscoots.com/user/dashboard?id=${docId}`,'WPO-Bigscoots');
		},
		async saveRecentlyAccessedUserToDB (id) {
			const adminData = await db.collection('users').doc(this.user.uid).get();
			let recentlyAccessedUser = adminData.data().recentlyAccessedUser ? adminData.data().recentlyAccessedUser : [];
			let customer=await db.collection('users').doc(id).get();
			customer=customer.data()
			let obj={
				id: id,
				name: `#${customer.customerID} ${customer.firstName} ${customer.lastName} ${customer.email}`,
				fullName: `${customer.firstName} ${customer.lastName}`,
				email: `${customer.email}`
			}
			if (recentlyAccessedUser.length > 0) {
				if (recentlyAccessedUser.length >= 10) {
					recentlyAccessedUser.splice(9, 1);
				}
				// if already exists in array
				if (recentlyAccessedUser.some(el => el.id === id)) {
					recentlyAccessedUser = recentlyAccessedUser.filter(el => el.id !== id);
				}
				recentlyAccessedUser.unshift(obj);
			} else {
				recentlyAccessedUser = [];
				recentlyAccessedUser.push(obj);
			}
			await db.collection('users').doc(this.user.uid).update({ recentlyAccessedUser: recentlyAccessedUser });
		},
		async loginAsUser(docId, backUrl) {
			if (backUrl) {
				localStorage.setItem('backUrl', backUrl)
			}
			if(localStorage.getItem('adminDtls')){
				const userDtls = JSON.parse(localStorage.getItem('userDtls'));
				swal({
					title: 'In User Mode',
					text: "Currently you are in " + userDtls.firstName + ' ' + userDtls.lastName,
					type: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#CCCCCC',
					confirmButtonText: 'Continue As User!',
					cancelButtonText: 'Back To Admin'
				}).then(result => {
					if(result.value){
						// localStorage.removeItem('accounts');
						this.$router.push({name: "userDashboard"});
					}else{
						let backUserId = JSON.parse(localStorage.getItem('userDtls')).uid;
						localStorage.setItem('userDtls', localStorage.getItem('adminDtls'));
						localStorage.removeItem('adminDtls');
						this.$router.push({ name: 'editUser', params: { docID: backUserId } })
					}
				});
				return false;
			}
			// if(this.userToken){
				const idToken = await auth.currentUser.getIdToken();
				db.collection("users").doc(docId).get().then(doc => {
										// Check if the document exists - then do more checks; Else throw error
					if (doc.exists) {
						const userDtls = {
							firstName: doc.data().firstName,
							isHR: doc.data().isHR,
							lastName: doc.data().lastName,
							email: doc.data().email,
							userType: doc.data().userType,
							customerID: doc.data().customerID ? doc.data().customerID : null,
							uid: doc.id,
							idToken: idToken,
							getNotificationStatus:  (doc.data().getNotificationStatus ===undefined) ? false : doc.data().getNotificationStatus
						};
						// Store the received data about the user in the Local Storage
						// localStorage.removeItem('accounts');
						let adminDtls = JSON.parse(localStorage.getItem('userDtls'));
						localStorage.setItem('adminDtls', JSON.stringify(adminDtls));
						localStorage.setItem("userDtls", JSON.stringify(userDtls));
						this.$store.dispatch('tasks/resetActiveSalesListener');
						this.$store.dispatch('tasks/resetActiveSupportListener');
						this.$store.dispatch('updateUserDetails', userDtls).then(()=>{
							this.$store.dispatch('customer/fetchUser').then(() => {
								this.$router.push({name: "userDashboard"});
							})
						});
					}else{
						swal({
							title: "Something went wrong!",
							html: "The required user is not exist in collection!",
							type: "error"
						});
					}
				});
			// }else{
			// 	swal({
			// 		title: "Something went wrong!",
			// 		html: "Please try Again!",
			// 		type: "error"
			// 	})
			// }
			// if (this.userToken) {
			// 	this.$http.post("auth/getToken", {
			// 		user_id: docId,
			// 		grant_type: "token",
			// 		token: this.userToken
			// 	})
			// 		.then((response) => {
			// 			auth.signOut().then(() => {
			// 				localStorage.setItem("loginAsUser", response.data.data.token);
			// 				localStorage.removeItem("userDtls");
			// 				localStorage.setItem('back_url', '/admin/user-list');
			// 				this.$router.push({name: "userDashboard"});
			// 			});
			// 			this.countRequests = 0;
			// 		})
			// 		.catch((err) => {
			// 			if (err.response.status == 401 && this.countRequests < 1) {
			// 				this.refreshToken(() => {
			// 					this.loginAsUser(docId)
			// 				})
			// 			}
			// 		})
			// 		.finally(() => {
			// 			this.countRequests++
			// 		})
			// } else {
			// 	auth.currentUser.getIdToken().then((idToken) => {
			// 		this.$store.dispatch('updateUserDetails', {...this.user, idToken: idToken});
			// 		localStorage.setItem('userDtls', JSON.stringify({...this.user, idToken: idToken}))
			// 	});
			// 	this.getServerToken(true);
			// 	swal({
			// 		title: "Something went wrong!",
			// 		html: "Please try Again!",
			// 		type: "error"
			// 	})
			// }
		},
		getServerToken(force = false) {
			return true;
            // if (!force && localStorage.getItem("adminToken")) {
			// 	return false;
			// }
			// if (this.userToken) {
			// 	this.$http.post("auth/getToken", {
			// 		user_id: this.user.uid,
			// 		grant_type: "token",
			// 		token: this.userToken
			// 	})
			// 		.then((response) => {
			// 			localStorage.setItem('adminToken', response.data.data.token);
			// 			this.countRequests = 0;
			// 		})
			// 		.catch((error) => {
			// 			localStorage.removeItem('adminToken');
			// 			if (error.response.status == 401 && this.countRequests < 1) {
			// 				this.refreshToken(() => {
			// 					this.getServerToken(true)
			// 				})
			// 			}
			// 		})
			// 		.finally(() => {
			// 			this.countRequests++
			// 		})
			// } else {
			// 	localStorage.removeItem('adminToken');
			// }
		}
	}
}
